export default __webpack_public_path__ + "static/media/logo-regenesis-final.3ebd3a86.svg";